type AllowUndefined<T> = {
    [P in keyof T]: T[P] | undefined;
};

export const createRecordFactory =
    <T>(defaults: AllowUndefined<T>) =>
    (record: Partial<T>): T =>
        ({
            ...defaults,
            ...record,
        }) as T;
